module.exports = __webpack_public_path__ + "media/src/images/lady-in-cafe-6c526dfdb111a79e4c446150ea33815d.jpg";